import { render } from "./NovusProfile.vue?vue&type=template&id=43b7ac94"
import script from "./NovusProfile.vue?vue&type=script&lang=js"
export * from "./NovusProfile.vue?vue&type=script&lang=js"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__